/**
 * tab content
 */
(() => {
  const textTabTitles = document.querySelectorAll('.service-tab-title');
  if (!textTabTitles) return;
  const textTabContents = document.querySelectorAll('.js-service-content');
  const tabImages = document.querySelectorAll('.module-image img');

  textTabTitles.forEach((tabTitle) => {
    tabTitle.addEventListener('click', (event) => {
      event.preventDefault();

      textTabTitles.forEach((title) => title.classList.remove('nActive'));
      textTabContents.forEach((content) => content.classList.remove('nActive'));
      tabImages.forEach((image) => image.classList.remove('nActive'));

      const tabId = tabTitle.getAttribute('tab-id');
      tabTitle.classList.add('nActive');
      document
        .querySelector(`.js-service-content[tab-id="${tabId}"]`)
        .classList.add('nActive');
      document
        .querySelector(`.module-image img[tab-id="${tabId}"]`)
        .classList.add('nActive');

      // sliding tab for 3 tabs
      const parentDiv = tabTitle.parentElement;
      if (tabId === '0') {
        parentDiv.classList.remove('mid', 'right');
        parentDiv.classList.add('left');
      } else if (tabId === '1') {
        parentDiv.classList.remove('left', 'right');
        parentDiv.classList.add('mid');
      } else if (tabId === '2') {
        parentDiv.classList.remove('left', 'mid');
        parentDiv.classList.add('right');
      }
    });
  });
})();
